<template>
  <div>
    <!-- tab开始 -->
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="全部" name="all"></el-tab-pane>
      <el-tab-pane label="在库" name="inStock"></el-tab-pane>
      <el-tab-pane label="已发" name="sented"></el-tab-pane>
    </el-tabs>
    <!-- tab结束 -->

    <TwTable
      :searchData="searchData"
      :tableData="tableData"
      :tableConfig="tableConfig"
      :pageConfig="pageConfig"
      :buttonList="buttonList"
      @btnCallFunction="callFunction"
      @resetBtn="resetBtn"
      @handleCellClick="handleCellClick"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox"
      @searchChange="searchChange"
      @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle"
      @handleSelsChange="handleSelsChange"
      @handleOperateEvent="handleOperateEvent"
    >
      <template v-slot:WarehouseId>
        <el-select
          multiple
          filterable
          v-model="filters.WarehouseId"
          placeholder="请选择"
          collapse-tags
        >
          <el-option
            v-for="item in warehouses"
            :label="item.warehouseName"
            :value="item.warehouseId"
            :key="item.warehouseId"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:OrgId>
        <el-select
          multiple
          filterable
          v-model="filters.OrgId"
          placeholder="请选择"
          collapse-tags
        >
          <el-option
            v-for="item in organizationList"
            :label="item.customName"
            :value="item.organizationId"
            :key="item.organizationId"
          ></el-option>
        </el-select>
      </template>

      <template slot-scope="scope" slot="receiptCount">
        <el-link
          :underline="false"
          type="primary"
          @click.native="batchesDetail(scope.row, 0)"
          >{{ scope.row.receiptCount }}
        </el-link>
      </template>
      <template slot-scope="scope" slot="boxCount">
        <el-link
          :underline="false"
          type="primary"
          @click.native="batchesDetail(scope.row, 10)"
          >{{ scope.row.boxCount }}
        </el-link>
      </template>
      <template slot-scope="scope" slot="sendBoxCount">
        <el-link
          :underline="false"
          type="primary"
          @click.native="batchesDetail(scope.row, 20)"
          >{{ scope.row.sendBoxCount }}
        </el-link>
      </template>

      <template slot-scope="scope" slot="palletCount">
        <el-link
          :underline="false"
          type="primary"
          @click.native="batchesPallet(scope.row)"
          >{{ scope.row.palletCount }}
        </el-link>
      </template>
    </TwTable>

    <LogDialog
      :logConfig="InOutDetailTableConfig"
      :showLog="showLogInOut"
      :requestData="{
        deliveryOrderID: currentRow.tfDeliveryOrderID,
        boxStatus: this.boxStatus,
      }"
      :requestApi="'/TFPutOnStock/GetTemporaryStorageInfoAsync'"
      :requestMethod="'get'"
      v-if="showLogInOut"
      @showDialog="showDialogInOut"
    ></LogDialog>

    <LogDialog
      :logConfig="PalletTableConfig"
      :showLog="showLogPallet"
      :requestData="{
        deliveryOrderID: currentRow.tfDeliveryOrderID,
      }"
      :requestApi="'/TFPutOnStock/GetPalletStorageInfoAsync'"
      :requestMethod="'get'"
      v-if="showLogPallet"
      @showDialog="showDialogPallet"
    ></LogDialog>
  </div>
</template>

<script>
import {
  getTemporaryStorageTaskAsync,
  exportTemporaryStorageAsyncOut,
  exportTemporarySKUStorageAsyncOut,
  exportTemporaryBoxStorageAsyncOut,
} from "@/api/transfer/tfPutOnStock/putOnStockManage.js";
import { getButtonList } from "../../../promissionRouter";
import TwTable from "../../../components/TwTable/TwTable";
import { TwTable_mixins } from "../../../components/TwTable/mixins";
import axios from "axios";
import { thereAre } from "util/util";
import LogDialog from "../../../components/TwTable/components/logDialog";
export default {
  components: { LogDialog, TwTable },
  mixins: [TwTable_mixins],
  data() {
    return {
      initColumn: [
        // 表格列配置
        {
          prop: "customName",
          label: "客户货主",
          align: "center",
          sortable: true,
          minWidth: "130",
        },
        {
          prop: "warehouseName",
          label: "仓库",
          align: "center",
          sortable: true,
          minWidth: "100",
        },
        {
          prop: "deliveryOrdeNo",
          label: "进仓单号",
          align: "center",
          sortable: true,
          minWidth: "180",
        },
        {
          prop: "orgCustomerNo",
          label: "参考单号",
          align: "center",
          sortable: true,
          minWidth: "200",
        },

        {
          prop: "createTimeText",
          label: "上架时间",
          align: "center",
          sortable: true,
          minWidth: "150",
        },
        {
          prop: "storages",
          label: "库位",
          align: "center",
          sortable: true,
          minWidth: "130",
        },
        {
          prop: "receiptCount",
          label: "收货箱数",
          align: "center",
          sortable: true,
          minWidth: "110",
          slot: true,
        },
        {
          prop: "boxCount",
          label: "在库箱数",
          align: "center",
          sortable: true,
          minWidth: "110",
          slot: true,
        },
        {
          prop: "palletCount",
          label: "在库卡板",
          align: "center",
          sortable: true,
          minWidth: "110",
          slot: true,
        },
        {
          prop: "sendBoxCount",
          label: "已发箱数",
          align: "center",
          sortable: true,
          minWidth: "110",
          slot: true,
        },
        {
          prop: "receivedBoxVolume",
          label: "在库体积",
          minWidth: "110",
        },
        {
          prop: "receivedBoxWeight",
          label: "在库重量",
          minWidth: "110",
        },
      ],
      activeName: "all",
      tableConfig: {
        showResetButton: true,
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: false, // 显示操作栏
        operate: {
          //操作栏配置
          align: "center",
          width: "120",
          options: [],
        },
        column: [],
      },
      searchData: {
        //搜索列配置

        search: [
          {
            type: "input",
            key: "DeliveryOrdeNo",
            label: "进仓单号",
            placeholder: "多个进仓单号用逗号分开查询",
            clearable: true,
          },

          {
            type: "input",
            key: "OrgCustomerNo",
            label: "参考单号",
            placeholder: "多个参考单号用逗号分开查询",
            clearable: true,
          },
          {
            type: "input",
            key: "SKUCode",
            label: "SKU编码",
            placeholder: "多个SKU编码用逗号分开查询",
            clearable: true,
          },
          {
            type: "select",
            key: "WarehouseId",
            prop: "WarehouseId",
            label: "仓库",
            multiple: true,
            slot: true,
            placeholder: "请选择仓库",
            option: this.warehouses,
          },
          {
            type: "select",
            key: "OrgId",
            prop: "OrgId",
            label: "客户货主",
            multiple: true,
            slot: true,
            placeholder: "请选择客户货主",
            option: this.organizationList,
          },
        ],
        ///高级搜索配置
        moreSearch: [
        ],
      },
      showLogInOut: false,
      showLogPallet:false,
      showDialogInout: false,
      InOutDetailTableConfig: {
        title: "库存箱明细",
        width: "70%",
        loading: true, // 显示loading状态
        showPage: true,
        column: [
          // 表格列配置
          {
            prop: "storages",
            label: "库位",
            align: "center",
            minWidth: "120",
          },
          {
            prop: "customerBox",
            label: "箱号",
            align: "center",
            minWidth: "150",
          },

          {
            prop: "boxMark",
            label: "箱唛",
            align: "center",
            minWidth: "160",
          },
          {
            prop: "boxStatusText",
            label: "状态",
            align: "center",
            minWidth: "100",
          },
          {
            prop: "actualBoxWeight",
            label: "毛重（kg）",
            align: "center",
            minWidth: "120",
          },
          {
            prop: "actualBoxVolume",
            label: "体积(cbm)",
            align: "center",
            minWidth: "100",
          },
          {
            prop: "actualBoxLength",
            label: "箱规(cm)",
            align: "center",
            minWidth: "100",
            formatter: function (val, row) {
              var html =
                row.actualBoxLength +
                "*" +
                row.actualBoxWidth +
                "*" +
                row.actualBoxHeight;
              return html;
            },
          },

          {
            prop: "quantity",
            label: "数量",
            align: "center",
          },
          {
            prop: "skuCode",
            label: "产品编码",
            align: "center",
          },
          {
            prop: "declareCName",
            label: "中文申报名称",
            align: "center",
            minWidth: "150",
          },

          {
            prop: "declareEName",
            label: "英文申报名称",
            align: "center",

            minWidth: "150",
          },
          {
            prop: "electricity",
            label: "是否含电",
            align: "center",

            minWidth: "100",
          },
        ],
      },

      PalletTableConfig: {
        title: "在库卡板信息",
        width: "50%",
        loading: true, // 显示loading状态
        showPage: true,
        column: [
          // 表格列配置
          {
            prop: "partCode",
            label: "SKU",
            align: "center",
            minWidth: "150",
          },
          {
            prop: "palletNo",
            label: "托唛号",
            align: "center",
            minWidth: "150",
          },
          {
            prop: "boxCount",
            label: "在库箱数",
            align: "center",
            minWidth: "150",
          },

          {
            prop: "storages",
            label: "库位",
            align: "center",
            minWidth: "160",
          },
        ],
      },

      buttonList: [],

      //-------------
      organizationList: [],
      warehouses: [],
      boxStatus: 0,
    };
  },
  methods: {
    handleClick(tab, event) {
      this.tableMacthColumn();
      this.initTable();
    },
    callFunction(item) {
      if (item.name === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
        this.newfilters = JSON.parse(JSON.stringify(this.filters));
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },
    // 根据在库、已发显示列表列
    tableMacthColumn() {
      let deepColumn = JSON.parse(JSON.stringify(this.initColumn));
      let newColumn = [];
      // 隐藏已发箱数或在库箱数
      let hideColumn =
        this.activeName != "all"
          ? this.activeName === "inStock"
            ? ["sendBoxCount"]
            : ["boxCount"]
          : [];
      deepColumn.forEach((element) => {
        // if(element.prop == 'receivedBoxVolume') {
        //   if(this.activeName === 'all'){
        //     element.label = '收货体积'
        //   }else if (this.activeName === 'inStock'){
        //     element.label = '在库体积'
        //   } else {
        //     element.label = '已发体积'
        //   }
        // }
        // if(element.prop == 'receivedBoxWeight') {
        //   if(this.activeName === 'all'){
        //     element.label = '收货重量'
        //   }else if (this.activeName === 'inStock'){
        //     element.label = '在库重量'
        //   } else {
        //     element.label = '已发重量'
        //   }
        // }
        if (!hideColumn.includes(element.prop)) {
          newColumn.push(element);
        }
      });
      this.$set(this.tableConfig, "column", newColumn);
    },
    resetBtn() {
      this.filters = {};
      this.$set(this.filters, "status", []);
    },
    //查询列表
    initTable() {
      console.info(this.newfilters);
      const {
        WarehouseId,
        OrgId,
        OrgCustomerNo,
        DeliveryOrdeNo,
        SKUCode,
        SKUCode2,
      } = this.newfilters;

      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        OrgCustomerNo,
        DeliveryOrdeNo,
        SKUCode,
        SKUCode2,
        WarehouseIDs: thereAre(WarehouseId),
        OrgId: thereAre(OrgId),
        stockType:
          this.activeName != "all" ? (this.activeName == "inStock" ? 1 : 2) : 0,
      };

      this.tableConfig.loading = true;
      this.tableConfig.showPage = false;
      getTemporaryStorageTaskAsync(para).then((res) => {
        const { total, pageData, pageIndex, pageSize } = res.data.response;

        this.$set(this.pageConfig, "total", total);
        this.$set(this.pageConfig, "pageIndex", pageIndex);
        this.$set(this.pageConfig, "pageSize", pageSize);
        this.tableData = pageData;
        this.tableConfig.loading = false;
        this.tableConfig.showPage = true;
      });
    },
    //导出
    handleExport() {
      let row = this.selectRows.rows;
      let TFDeliveryOrderIDs = row
        .map((item) => item.tfDeliveryOrderID)
        .join(",");
      const { WarehouseId, OrgId, OrgCustomerNo, DeliveryOrdeNo } =
        this.newfilters;
      let para = {
        page: 1,
        pageSize: 60001,
        DeliveryOrdeNo,
        OrgCustomerNo,
        WarehouseIDs: thereAre(WarehouseId),
        OrgId: thereAre(OrgId),
        TFDeliveryOrderIDs,
        stockType:
          this.activeName != "all" ? (this.activeName == "inStock" ? 1 : 2) : 0,
      };

      const loading = this.$loading({
        lock: true,
        text: "导出中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios({
        url: exportTemporaryStorageAsyncOut,
        method: "post",
        data: para,
        //responseType: "blob",
      })
        .then((res) => {
          console.log(res);
          loading.close();
          if (res.data.success) {
            var data = res.data.response;

            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    //导出产品库存
    handleSKUExport() {
      let row = this.selectRows.rows;
      let TFDeliveryOrderIDs = row
        .map((item) => item.tfDeliveryOrderID)
        .join(",");
      const { WarehouseId, OrgId, OrgCustomerNo, DeliveryOrdeNo } =
        this.newfilters;
      let para = {
        page: 0,
        pageSize: 60001,
        OrgCustomerNo,
        DeliveryOrdeNo,
        WarehouseIDs: thereAre(WarehouseId),
        OrgId: thereAre(OrgId),
        TFDeliveryOrderIDs,
        stockType:
          this.activeName != "all" ? (this.activeName == "inStock" ? 1 : 2) : 0,
      };

      const loading = this.$loading({
        lock: true,
        text: "导出中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios({
        url: exportTemporarySKUStorageAsyncOut,
        method: "post",
        data: para,
        //responseType: "blob",
      })
        .then((res) => {
          console.log(res);
          loading.close();
          if (res.data.success) {
            var data = res.data.response;

            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    //导出箱明细
    handleBoxExport() {
      let row = this.selectRows.rows;
      let TFDeliveryOrderIDs = row
        .map((item) => item.tfDeliveryOrderID)
        .join(",");
      const { WarehouseId, OrgId, OrgCustomerNo, DeliveryOrdeNo } =
        this.newfilters;
      let para = {
        page: 0,
        pageSize: 60001,
        OrgCustomerNo,
        DeliveryOrdeNo,
        WarehouseIDs: thereAre(WarehouseId),
        OrgId: thereAre(OrgId),
        TFDeliveryOrderIDs,
        stockType:
          this.activeName != "all" ? (this.activeName == "inStock" ? 1 : 2) : 0,
      };

      const loading = this.$loading({
        lock: true,
        text: "导出中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios({
        url: exportTemporaryBoxStorageAsyncOut,
        method: "post",
        data: para,
        //responseType: "blob",
      })
        .then((res) => {
          console.log(res);
          loading.close();
          if (res.data.success) {
            var data = res.data.response;

            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    //查询日志
    getbusinessLoglist(row) {
      this.currentRow = row;
      this.showLog = true;
    },
    //查询明细
    batchesDetail(rows, boxStatus) {
      this.currentRow = rows;
      this.showLogInOut = true;
      this.boxStatus = boxStatus;
    },
    showDialogInOut() {
      this.showLogInOut = !this.showLogInOut;
    },


    batchesPallet(rows) {
      this.currentRow = rows;
      this.showLogPallet = true;
    },
    showDialogPallet() {
      this.showLogPallet = !this.showLogPallet;
    },
    
    //单选选中复选框
    handleCellClick(row, column, event) {
      this.tableEle.toggleRowSelection(row);
    },
  },

  mounted() {
    this.tableMacthColumn();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];

    this.buttonList = getButtonList(this.$route.path, routers);

    let user = JSON.parse(window.localStorage.user);
    this.organizationList = user.organizationList;
    this.warehouses = user.warehouseList;
  },
};
</script>

<style scoped>
.dateSelect {
  width: 130px;
  margin-right: 12px;
}
</style>